import { useEffect, useRef } from "react";
import { animate, useInView } from "framer-motion";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../lib/SiteContext";
import { Reveal, Overline } from "./Reveal";

const Count = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const num = /^\d+$/.test(String(value)) ? Number(value) : null;
  useEffect(() => {
    if (!inView || num === null || !ref.current) return undefined;
    const c = animate(0, num, { duration: 1.8, ease: "easeOut", onUpdate: (v) => { if (ref.current) ref.current.textContent = Math.round(v); } });
    return () => c.stop();
  }, [inView, num]);
  return <span ref={ref}>{value}</span>;
};

export const Impact = () => {
  const { t, lang } = useLang();
  const { settings } = useSite();
  const stats = Array.isArray(settings.stats) ? settings.stats : [];

  return (
    <section id="impact" className="relative overflow-hidden py-24 lg:py-32" data-testid="impact-stats">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="max-w-3xl">
          <Overline>{t.impact.over}</Overline>
          <h2 className="section-title mt-5">{t.impact.title}</h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-2 border-t border-white/10 lg:grid-cols-4">
          {stats.map((s, i) => (
            <Reveal key={i} delay={i * 0.1} className="border-b border-white/10 py-10 pr-4 lg:border-b-0 lg:border-r lg:px-8 lg:first:pl-0 lg:last:border-r-0">
              <p className="font-display text-6xl font-extrabold tracking-tight text-white lg:text-7xl" data-testid={`impact-stat-${i}`}>
                <Count value={s?.value ?? ""} />
                <span className="text-saffron">+</span>
              </p>
              <p className="mt-3 text-sm text-slate-300">{lang === "hi" ? s?.label_hi : s?.label_en}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
